import http from '@/utils/http'

export default {
  flowList: data => http({ url: '/api/admin/v1/yeepayFinance/flowList', data }),
  flowDetail: data => http({ url: '/api/admin/v1/yeepayFinance/flowDetail', data }),
  callbackExport: data => http({ url: '/api/admin/v1/yeepayFinance/callbackExport', data }),
  retrySplit: data => http({ url: '/api/admin/v1/yeepayFinance/retrySplit', data, tip: true }),
}
